module.exports = __webpack_public_path__ + "static/img/アセット 27@2x.7bf514c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 27@2x.png
// module id = +yz8
// module chunks = 1